<template>
  <section class="about-overview">
    <div class="about-overview__content">
      <div class="about-overview__description">
        <p
          class="about-overview__description--paragraph about-overview__description--paragraph-space"
        >
          「まとめてオーダー」とは、株式会社ギフティが<br
            class="less-than-pc-br"
          />個人のユーザー様から<br class="pc-br" />オンラインギフトの<br
            class="less-than-pc-br"
          />大量発注をお受けするサービスです。
        </p>
        <p class="about-overview__description--paragraph">
          <span class="about-overview__description--span">
            ご希望の内容・件数のギフトのURLを発行し、
          </span>
          <span class="about-overview__description--span">
            CSV形式で納品。
          </span>
        </p>
        <p class="about-overview__description--paragraph">
          <span class="about-overview__description--span">
            URLを渡すだけでギフトが贈れるので、
          </span>
          <span class="about-overview__description--span">
            大人数にギフトを配布したい時に便利です。
          </span>
        </p>
      </div>
    </div>
    <div class="about-overview__merit-content">
      <h3 class="about-overview__title">
        <span class="about-overview__title--wrap">
          まとめてオーダーの<br class="less-than-pc-br" />メリット
        </span>
      </h3>
      <div class="about-overview__merit-flow">
        <div class="about-overview__merit-item">
          <p class="about-overview__merit-item--title">
            <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
            <span>ギフティがご希望の内容で</span><span>オンラインギフトを大量発行</span>
          </p>
          <ImgLazy
            :image-url="BulkOrderMerit1Image"
            alt-text="ギフティがご希望の内容でオンラインギフトを大量発行"
            aspect-ratio="1025 / 657"
            image-class="about-overview__merit-item--image"
          />
        </div>
        <ImgLazy
          :image-url="NextIconHorizontalImage"
          alt-text=""
          aspect-ratio="71 / 82"
          :width="23.25"
          class="about-overview__merit-item--next-icon-horizontal mx-4"
        />
        <ImgLazy
          :image-url="NextIconVerticalImage"
          alt-text=""
          aspect-ratio="71 / 82"
          :width="23.25"
          class="about-overview__merit-item--next-icon-vertical my-4"
        />
        <div class="about-overview__merit-item">
          <p class="about-overview__merit-item--title">
            <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
            <span>ギフトはURL形式なので</span><span>メールなどで送付するだけ</span>
          </p>
          <ImgLazy
            :image-url="BulkOrderMerit2Image"
            alt-text="ギフトはURL形式なのでメールなどで送付するだけ"
            aspect-ratio="1025 / 657"
            class="about-overview__merit-item--image"
          />
        </div>
        <ImgLazy
          :image-url="NextIconHorizontalImage"
          alt-text=""
          aspect-ratio="71 / 82"
          :width="23.25"
          class="about-overview__merit-item--next-icon-horizontal mx-4"
        />
        <ImgLazy
          :image-url="NextIconVerticalImage"
          alt-text=""
          aspect-ratio="71 / 82"
          :width="23.25"
          class="about-overview__merit-item--next-icon-vertical my-4"
        />
        <div class="about-overview__merit-item">
          <p class="about-overview__merit-item--title">
            <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
            <span>おひとりずつに</span><span>ギフトの配布が完了！</span>
          </p>
          <ImgLazy
            :image-url="BulkOrderMerit3Image"
            alt-text="おひとりずつにギフトの配布が完了！"
            aspect-ratio="1025 / 657"
            image-class="about-overview__merit-item--image"
          />
        </div>
      </div>
      <div class="about-overview__merit-text mt-48">
        <p class="about-overview__merit-text--normal">
          <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
          <span>ギフティがご希望のギフトを</span><span>発行してお渡しするので、</span>
        </p>
        <p class="about-overview__merit-text--bold">
          <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
          <span>ギフトを1件1件購入する</span><span>手間がかかりません。</span>
        </p>
      </div>
      <div class="about-overview__merit-text mt-16">
        <p>
          <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
          <span class="about-overview__merit-text--bold">11件以上から</span><span class="about-overview__merit-text--normal">ご注文を承ります。</span>
        </p>
      </div>
      <div class="about-overview__merit-text mt-16">
        <p class="about-overview__merit-text--bold">
          オリジナルのイラストや写真も
        </p>
        <p class="about-overview__merit-text--normal">
          <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
          <span>メッセージを添えて</span><span>ギフトカードとしてお贈りいただけます。</span>
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import BulkOrderMerit1Image from '../../../../../../images/bulk_personal_orders/about/merits/bulk_order_merit1.png'
import BulkOrderMerit2Image from '../../../../../../images/bulk_personal_orders/about/merits/bulk_order_merit2.png'
import BulkOrderMerit3Image from '../../../../../../images/bulk_personal_orders/about/merits/bulk_order_merit3.png'
import NextIconHorizontalImage from '../../../../../../images/bulk_personal_orders/about/next_icon_horizontal.png'
import NextIconVerticalImage from '../../../../../../images/bulk_personal_orders/about/next_icon_vertical.png'
</script>

<style lang="scss" scoped>
.about-overview {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $white;

  &__content {
    width: 100%;
    max-width: 1440px;
    padding: 30px 72px 0;
    box-sizing: border-box;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 30px 56px 0;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 30px 24px 0;
    }
  }

  &__description {
    &--paragraph-space {
      margin-bottom: calc(2.4rem * 1.583); // 1行分

      @media all and (max-width: ($pc-width - 1)) {
        margin-bottom: calc(1.4rem * 1.6); // 1行分
      }
    }

    &--paragraph {
      text-align: center;
      color: $black;
      font-size: 2.4rem;
      line-height: 1.583;
      letter-spacing: 0;
      @media all and (max-width: ($pc-width - 1)) {
        font-size: 1.4rem;
        line-height: 1.6;
      }
    }

    &--span {
      @media all and (max-width: ($pc-width - 1)) {
        display: block;
      }
    }
  }

  &__merit-content {
    width: 100%;
    max-width: 1440px;
    padding: 159px 72px 96px;
    box-sizing: border-box;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 80px 56px 64px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 80px 24px 64px;
    }
  }

  &__title {
    color: $primary;
    font-weight: bold;
    font-size: 4.4rem;
    line-height: 1.6;
    position: relative;

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 2.8rem;
    }

    &--wrap {
      display: inline-block;
    }

    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      width: 109px;
      height: 116px;
      background-image: url('../../../../../../images/bulk_personal_orders/about/emotion_notice.png');
      background-position: center;
      background-size: contain;
      top: -63px;

      @media all and (max-width: ($pc-width  - 1)) {
        top: -16px;
        width: 54px;
        height: 57px;
      }
    }
  }

  &__merit-flow {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 48px 0;

    @media all and (max-width: ($pc-width  - 1)) {
      margin: 24px 0;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      flex-direction: column;
    }
  }

  &__merit-item {
    border: solid 5px $primary-lighten;
    border-radius: 32px;
    padding: 32px 16px;
    box-sizing: border-box;

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 30px 16px;
      max-width: none;
      width: 100%;
    }

    &--title {
      font-size: 1.8rem;
      font-weight: bold;
      color: $black;
      line-height: 1.6;
      margin-bottom: 24px;

      @media all and (max-width: ($pc-width  - 1)) {
        font-size: 1.4rem;
      }

      & > span {
        display: block;
      }
    }

    &--image {
      width: 100%;
      object-fit: contain;

      @media all and (max-width: ($base-contents-width - 1)) {
        max-width: 495px;
      }
    }

    &--next-icon-horizontal {
      width: 23.25px;
      object-fit: contain;
      overflow: visible;

      @media all and (max-width: ($base-contents-width - 1)) {
        display: none;
      }
    }

    &--next-icon-vertical {
      width: 23.25px;
      object-fit: contain;
      overflow: visible;
      display: none;

      @media all and (max-width: ($base-contents-width - 1)) {
        display: block;
      }
    }
  }

  &__merit-text {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: $primary-lighten;
    border-radius: 32px;
    padding: 32px 16px;
    max-height: 135px;
    min-height: 88px;
    box-sizing: border-box;

    &--normal {
      color: $black;
      font-weight: bold;
      font-size: 1.8rem;
      line-height: 2;

      @media all and (max-width: ($pc-width  - 1)) {
        font-size: 1.4rem;
        line-height: 1.43;

        & > span {
          display: block;
        }
      }
    }

    &--bold {
      color: $primary;
      font-weight: bold;
      font-size: 2.4rem;
      line-height: 1.5;

      @media all and (max-width: ($pc-width  - 1)) {
        font-size: 1.8rem;
        line-height: 1.67;

        & > span {
          display: block;

          &:last-child {
            line-height: 1.39;
          }
        }
      }
    }
  }
}

// PCサイズ未満のときの改行
.less-than-pc-br {
  display: none;
  @media all and (max-width: ($pc-width - 1)) {
    display: block;
  }
}

// PCサイズのときの改行
.pc-br {
  @media all and (max-width: ($pc-width - 1)) {
    display: none;
  }
}
</style>
